import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Landing } from './pages/Landing';
import { Refund } from './pages/Refund';
import { Privacy } from './pages/Privacy';
import { Terms } from './pages/Terms';
import { StickyMobileCTA } from './components/StickyMobileCTA';
import { GTM } from './components/GTM';
import { FacebookDomainVerification } from './components/FacebookDomainVerification';
export function App() {
  return <BrowserRouter data-id="element-0">
      <FacebookDomainVerification data-id="element-1" />
      <GTM data-id="element-2" />
      <Routes data-id="element-3">
        <Route path="/" element={<Landing data-id="element-5" />} data-id="element-4" />
        <Route path="/refund" element={<Refund data-id="element-7" />} data-id="element-6" />
        <Route path="/privacy" element={<Privacy data-id="element-9" />} data-id="element-8" />
        <Route path="/terms" element={<Terms data-id="element-11" />} data-id="element-10" />
      </Routes>
      <StickyMobileCTA data-id="element-12" />
    </BrowserRouter>;
}